import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import {
  isShowDonePanel,
  isShowStoryForm,
  isShowControlPanel,
  isShowStoryFormForYesterdayActivity,
  isShowDonePanelForYesterdayActivity,
  isCommitNotificationTimeHasCome,
  isUserHaveOnlyFirstActivity,
} from 'store/entities/identity/selectors'
import UserActivityBlock from './UserActivityBlock'

const mapStateToProps = createStructuredSelector({
  isShowDonePanel,
  isShowStoryForm,
  isShowControlPanel,
  isShowStoryFormForYesterdayActivity,
  isShowDonePanelForYesterdayActivity,
  isCommitNotificationTimeHasCome,
  isUserHaveOnlyFirstActivity,
})

export default connect(mapStateToProps)(UserActivityBlock)
